// frontend/src/components/ChatInterface.jsx
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MessageBubble from './MessageBubble';
import QuestionInput from './QuestionInput';
import PrivacyNotice from './PrivacyNotice';
import { useChat } from '../hooks/useChat';
import { useAuth } from '../context/AuthContext';

const ChatInterface = () => {
  const { 
    messages, 
    loading, 
    sendMessage, 
    provideFeedback 
  } = useChat();
  
  const { logout } = useAuth();
  const navigate = useNavigate();
  const chatEndRef = useRef(null);
  
  // Scroll to bottom when messages change
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <header className="bg-indigo-600 text-white p-4 flex justify-between items-center shadow-md">
        <h1 className="text-xl font-semibold">Ask Me Anything: Relationships</h1>
        <button
          onClick={handleLogout}
          className="bg-indigo-700 text-white text-sm px-3 py-1 rounded hover:bg-indigo-800"
        >
          Logout
        </button>
      </header>
      
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {messages.length === 0 && (
          <div className="text-center p-8 text-gray-500">
            <p className="mb-2 text-lg">
              Welcome to "Ask Me Anything" about responsible relationships.
            </p>
            <p>
              Feel free to ask questions you might be hesitant to ask in class.
              All questions are anonymous.
            </p>
          </div>
        )}
        
        {messages.map((msg, index) => (
          <MessageBubble 
            key={index} 
            message={msg} 
            onFeedback={provideFeedback} 
          />
        ))}
        
        <div ref={chatEndRef} />
      </div>
      
      <div className="border-t border-gray-200 p-4">
        <PrivacyNotice />
        <QuestionInput onSend={sendMessage} isLoading={loading} />
      </div>
    </div>
  );
};

export default ChatInterface;